"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGuidLabel = exports.isKnownGuid = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _utils = require("I18n/utils");

/**
 * Known GUID constants queued for deprecation
 *
 * @constants
 * @private
 */
var deprecated = {
  GMAIL_INTEGRATION: 'GMAIL_INTEGRATION'
};
/**
 * Known GUID constants keyed by name
 *
 * @constants
 * @private
 */

var constants = (0, _immutable.Map)((0, _extends2.default)({
  NO_BREAKDOWN: 'nobreakdown',
  NO_DETAIL_GUID: 'c90e6907-e895-479c-8689-0d22fa660677',
  EMPTY_LIST_GUID: '30434570-5795-496c-b0ae-8d2dc9053483',
  UNKNOWN: '5ca1ab1e-fb50-4e89-9cff-a000ba5eba11',
  UNKNOWN_CAMPAIGN_GUID: '9bae4a1c-0f1c-11e1-9afb-58b0357d1cb3',
  UNKNOWN_COUNTRY_GUID: 'bd185678-735d-4c78-a673-d9528d37a4a6',
  UNKNOWN_KEYWORD_GUID: 'c1d25565-f664-4089-9f0a-1734cc1b3a65',
  UNKNOWN_REFERRER_GUID: '1ca35c16-25e9-49f1-bfcb-960300c42b6f',
  UNKNOWN_GEO_GUID: '7081c5b2-d128-4ec1-a9be-cba29cfc540a',
  UNKNOWN_URL: 'e3875d32-ab81-48f1-9e78-493eae864f12',
  SSL_REMOVED_KEYWORDS: 'Unknown keywords (SSL)',
  LYCOS_IMAGE_KEYWORD_PLACEHOLDER: 'Unknown keywords (image preview)',
  PPC_GCLID_BUCKET: 'Auto-tagged PPC',
  EMAIL_INTEGRATION: 'EMAIL_INTEGRATION',
  BCC_TO_CRM: 'BCC_TO_CRM'
}, deprecated));
/**
 * Known GUID constants keyed by GUID
 *
 * @constants
 * @private
 */

var guids = constants.flip();
/**
 * Check whether GUID is known
 *
 * @param {string} guid GUID to check
 * @returns {boolean} Whether GUID is known
 */

var isKnownGuid = function isKnownGuid(guid) {
  return guids.has(guid);
};
/**
 * Get humanized label from GUID
 *
 * @param {string} guid GUID to humanize
 * @returns {string} Label if known otherwise original value
 */


exports.isKnownGuid = isKnownGuid;

var getGuidLabel = function getGuidLabel(guid) {
  return isKnownGuid(guid) ? (0, _utils.text)("reporting-data.guids." + guids.get(guid)) : guid;
};

exports.getGuidLabel = getGuidLabel;